import React, { useState } from 'react';
import './unavailableRoom.css';
import { CgSpinner } from 'react-icons/cg';
import { FaTrashAlt } from 'react-icons/fa';
import EditRoomButton from './editRoomButton.js';


// props:
// lesson - identifier for the lesson slot
// cancelBookingFunction - API handler used to cancel the booking
// room - identifier for the room
// roomName - display name of the room
// onEditClick - optional handler to open the edit questions modal

// Displays an occupied booking cell with optional edit and cancel controls.
// Only clicking the bin icon will trigger the cancellation handler.
export default function UnavailableRoom(props) {
    // State to track when the cancel action is processing
    const [isCancelling, setIsCancelling] = useState(false);

    // Handle the cancel request and prevent multiple clicks while processing
    const handleCancelClick = async () => {
        if (isCancelling) return; // Ignore additional clicks during processing

        // If a custom cancel click handler is provided (e.g., bulk cancel flow),
        // still show the spinner while it runs so the UI matches normal booking.
        if (typeof props.onCancelClick === 'function') {
            setIsCancelling(true);
            try {
                const maybePromise = props.onCancelClick();
                if (maybePromise && typeof maybePromise.then === 'function') {
                    await maybePromise;
                }
            } finally {
                setIsCancelling(false);
            }
            return;
        }

        setIsCancelling(true);
        try {
            await props.cancelBookingFunction('cancel', props.room, props.lesson, '[]', props.roomName);
        } finally {
            setIsCancelling(false);
        }
    };

    return (
        <div className='unavailableRoom'>
            <div className='unavailableRoomText'>
                {isCancelling ? (
                    <CgSpinner className='unavailableRoomSpinner' />
                ) : (
                    <>
                        {props.user}
                        <br />
                        {props.class}
                    </>
                )}
            </div>
            <div className='unavailableRoomIcons'>
                {props.onEditClick && <EditRoomButton onClick={props.onEditClick} />}
                <FaTrashAlt className='unavailableRoomBinIcon' onClick={handleCancelClick} />
            </div>
        </div>
    );
};
